import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//@ts-nocheck
//nocheck for now since there are some unused vars being saved for later
import { Modal, SubmitButton } from 'lp-components';
import { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { compose } from 'redux';
import { PRE_QUALIFICATION_DECLINED_URL, PRE_QUALIFICATION_ACCOUNT_EXISTS_URL, WIZARD_URL, ACCESS_LOAN_URL, } from 'shared';
import { selectors } from '../reducer';
function PrequalAcceptDeclineModal({ onClose, payload, practice, }) {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    // Keeping this for later.
    const requestPrequalification = () => {
        //empty for now.
    };
    // Keeping this for later.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const reApplyForPreQualification = () => {
        setLoading(true);
        return requestPrequalification(payload).then((prequalification) => {
            const { applicationStatus, lenderNextStepUrl } = prequalification;
            setLoading(false);
            if (applicationStatus === 'prequalified') {
                history.push({
                    pathname: WIZARD_URL,
                    state: {
                        step: 'PRE-QUALIFICATION',
                    },
                });
            }
            else if (applicationStatus === 'prequalified_account_exists') {
                history.push(PRE_QUALIFICATION_ACCOUNT_EXISTS_URL);
            }
            else if (applicationStatus === 'pending_approval') {
                // "An assumption is currently made that pending_approval is returned only for access loans. If additional product types associated with
                //  a pending_approval status will be supported, this code this have to be revisited to accommodate them."
                history.push({
                    pathname: ACCESS_LOAN_URL,
                    state: {
                        lenderNextStepUrl,
                        applicationStatus,
                    },
                });
            }
            else {
                history.push(PRE_QUALIFICATION_DECLINED_URL);
            }
        });
    };
    return (_jsx(Modal, { onClose: onClose, overlayClassName: "modal-fade-screen prequal-decline-modal-overlay", className: "modal-inner prequal-decline-modal modal", children: _jsx("div", { children: _jsxs("div", { className: "prequal-decline-modal__container", children: [_jsxs("div", { className: "details", children: ["We were unable to approve you for an Alphaeon Credit Card. You will receive an explanation letter in 7-10 business days.", _jsx("br", {}), _jsx("br", {}), "However, we were able to pre-qualify you for our Access Loan", practice && ` at ${practice.name}`, "."] }), _jsx("div", { className: "button-block", children: _jsx(SubmitButton, { className: "button-warn-outline", disabled: loading, submitting: loading, onClick: () => onClose(), children: "Continue" }) })] }) }) }));
}
function mapStateToProps(state) {
    return {
        personalInfo: selectors.personalInfo(state),
        practice: selectors.practice(state),
    };
}
const mapDispatchToProps = {};
export default compose(connect(mapStateToProps, mapDispatchToProps))(PrequalAcceptDeclineModal);
